import { render, staticRenderFns } from "./yzm.vue?vue&type=template&id=40056fce&"
import script from "./yzm.vue?vue&type=script&lang=js&"
export * from "./yzm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports